import(/* webpackMode: "eager" */ "/workspace/purpose-it/purpose-fe-monorepo/apps/web/app/[locale]/page.tsx");
